import React, { useState } from 'react'
import { Button } from '@livechat/design-system-react-components'
import { string } from 'prop-types'
import { useDispatch } from 'react-redux'

import { requestAccessToProduct } from '@/store/subscription'

const RequestProductAccessButton = ({ designation, ...props }) => {
  const [isRequestSent, setIsRequestSent] = useState(false)

  const dispatch = useDispatch()

  const handleRequestAccessClick = () => {
    setIsRequestSent(true)
    dispatch(requestAccessToProduct({ designation }))
  }

  return (
    <Button
      size="compact"
      kind="primary"
      fullWidth
      className="confirm-button"
      disabled={isRequestSent}
      onClick={handleRequestAccessClick}
      {...props}
    >
      Request {isRequestSent ? 'sent' : 'access'}
    </Button>
  )
}

RequestProductAccessButton.propTypes = {
  designation: string,
}

export default RequestProductAccessButton
